module.exports = __webpack_public_path__ + "img/cote_st_luc.2185dc8d.webp";